import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  Pagination,
  Radio,
  Row,
  Select,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import inquiryApi from "../../../apis/Inquiry.api";
import {
  setLoading,
  setSearchText,
} from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import InquiryComponent from "./InquiryComponent";

const ProductInquiryComponent = () => {
  const dispatch = useDispatch();

  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);
  const searchText = useSelector((state) => state.common.searchText);
  const recordDates = useSelector((state) => state.common.recordDates);

  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(false);
  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
    answerStatus: "total",
    searchType: "product",
    searchValue: "",
  });
  const [inquiryList, setInquiryList] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [error, setError] = useState("");

  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const answerStatusItems = [
    { label: "전체", value: "total" },
    { label: "미답변", value: "unanswered" },
    { label: "답변완료", value: "answered" },
  ];
  const searchTypeItems = [
    { label: "상품명", value: "product" },
    { label: "상품번호", value: "product_id" },
  ];

  useEffect(() => {
    if (searchText && searchText !== " ") {
      if (searchText === "unanswer") {
        setDateType("");
        setSearchOptions({
          ...searchOptions,
          startDate: recordDates.startDate,
          endDate: recordDates.endDate,
          answerStatus: "unanswered",
        });
        readInquiryList(
          "custom",
          recordDates.startDate,
          recordDates.endDate,
          "unanswered",
        );
      } else {
        readInquiry(searchText);
      }
    } else {
      handleInitialBtnClick();
    }
  }, [searchText]);

  useEffect(() => {
    readInquiryList();
  }, [offset]);

  const readInquiry = async (question_id) => {
    setIsLoading(true);
    try {
      const res = await inquiryApi.readProductInquiryOne(question_id);
      if (res.code === 200) {
        setIsLoading(false);
        setInquiryList([res.result]);
        setTotalSize(1);
      } else {
        throw res.msg;
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("readInquiry read one error", error);
      alert(error);
    }
  };

  const readInquiryList = async (
    type = "",
    startDate,
    endDate,
    answerStatus,
  ) => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await inquiryApi.readProductInquiryList(
          0,
          15,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          answerStatusItems[0].value,
          searchTypeItems[0].value,
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "search") {
        res = await inquiryApi.readProductInquiryList(
          0,
          15,
          searchOptions.startDate.format("YYYYMMDDHHmm"),
          searchOptions.endDate.format("YYYYMMDDHHmm"),
          searchOptions.answerStatus,
          searchOptions.searchType,
          searchOptions.searchValue,
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "custom") {
        res = await inquiryApi.readProductInquiryList(
          offset,
          15,
          startDate.format("YYYYMMDDHHmm"),
          endDate.format("YYYYMMDDHHmm"),
          answerStatus,
          searchOptions.searchType,
          searchOptions.searchValue,
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await inquiryApi.readProductInquiryList(
          offset,
          15,
          searchOptions.startDate.format("YYYYMMDDHHmm"),
          searchOptions.endDate.format("YYYYMMDDHHmm"),
          searchOptions.answerStatus,
          searchOptions.searchType,
          searchOptions.searchValue,
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        console.log("readInquiryList result", res.result);
        setInquiryList(res.result.userProductQuestionHistoryDTOList);
        setTotalSize(res.result.totalCnt);
      } else {
        throw "해당 문의 리스트 정보를 가져오는데 실패했습니다.\n다시 시도하시거나 관리자에게 문의하시길 바랍니다.";
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("readInquiryList read error", error);
      alert(error);
    }
  };

  /**
   * 상품문의 답변 등록 및 수정
   */
  const registerInquiryAnswer = async (
    inquiry,
    answer,
    type,
    answerContentOpenBtnClick,
    editCancelBtnClick,
  ) => {
    setIsLoading(true);
    try {
      let res;
      let param = {
        id: inquiry.id,
        answer_body: answer,
        answer_created_by: user.id === 724 ? 1 : user.id,
      };
      if (type === "create") {
        res = await inquiryApi.createProductInquiryAnswer(param);
      } else {
        res = await inquiryApi.editProductInquiryAnswer(param);
      }
      if (res.code === 200) {
        setIsLoading(false);
        alert("해당 문의에 대한 답변을 성공적으로 등록했습니다.");
        if (type === "edit") {
          editCancelBtnClick();
        } else {
          answerContentOpenBtnClick();
        }
        readInquiryList();
      } else {
        throw res.msg;
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("registerInquiryAnswer register error", error);
      alert(error);
    }
  };

  /**
   * 상품문의 답변 삭제
   */
  const deleteAnswerBtnClick = async (inquiry) => {
    console.log("deleteAnswerBtnClick", inquiry);
    if (
      window.confirm(
        "답변을 삭제하면 해당 문의는 답변완료 전 상태로 되돌아갑니다. 그래도 삭제하시겠습니까?",
      )
    ) {
      setIsLoading(true);
      try {
        let param = {
          id: inquiry.id,
          answer_created_by: user.id === 724 ? 1 : user.id,
        };
        const res = await inquiryApi.deleteProductInquiryAnswer(param);
        if (res.code === 200) {
          setIsLoading(false);
          alert("해당 문의에 대한 답변 정보 삭제에 성공했습니다.");
          readInquiryList();
        } else {
          throw res.msg;
        }
      } catch (error) {
        setIsLoading(false);
        setError(error);
        console.log("readInquiryList read error", error);
        alert(error);
      }
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setSearchText("");
    setOffset(0);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        setInquiryList([]);
        readInquiryList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
      answerStatus: "total",
      searchType: "product",
      searchValue: "",
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    readInquiryList("initial");
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * 15;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  return (
    <>
      <ContentHeaderComponent title="문의관리" />
      <div className="product-register-wrap">
        <Row
          className="product-register-border-box"
          justify="space-between"
          wrap={false}
          style={{ marginTop: 25 }}
        >
          <div>
            <span className="product-register-box-title">
              문의목록 (총 <span className="text-highlight">{totalSize}</span>
              개)
            </span>
          </div>
          <img
            className="search-filter-img-wrap"
            src={`${
              process.env.REACT_APP_HOST
            }/assets/images/inquiry/search_filter_${
              isSearchBoxOpen ? "up" : "down"
            }.png`}
            style={{
              cursor: "pointer",
            }}
            onClick={() => setIsSearchBoxOpen(!isSearchBoxOpen)}
          />
        </Row>
        {isSearchBoxOpen ? (
          <Row
            className="product-search-box-wrap"
            style={{ marginTop: 0, borderTop: 0, backgroundColor: "#f8f9fd" }}
          >
            <Form.Item
              // className="center-label"
              label="조회기간"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              <Row align={"middle"} style={{ gap: "5px" }}>
                <Radio.Group
                  className={`options-list`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className="order-search-date-wrap"
                  format="YYYY/MM/DD"
                  allowClear={false}
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType("");
                    setSearchOptions({ ...searchOptions, startDate: value });
                  }}
                />
                ~
                <DatePicker
                  className="order-search-date-wrap"
                  format="YYYY/MM/DD"
                  allowClear={false}
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType("");
                    setSearchOptions({ ...searchOptions, endDate: value });
                  }}
                />
              </Row>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="center-label"
              label="답변상태"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              <Select
                value={searchOptions.answerStatus}
                onChange={(value) =>
                  setSearchOptions({ ...searchOptions, answerStatus: value })
                }
                style={{ width: 200, textAlign: "left" }}
              >
                {answerStatusItems.map((item, idx) => (
                  <Option
                    key={`answer_status_search_${idx}`}
                    value={item.value}
                  >
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="center-label"
              label="검색어"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              <Select
                value={searchOptions.searchType}
                onChange={(value) =>
                  setSearchOptions({ ...searchOptions, searchType: value })
                }
                style={{ width: 200, textAlign: "left" }}
              >
                {searchTypeItems.map((item, idx) => (
                  <Option key={`search_type_${idx}`} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
              <Input
                className="inquiry-search-input-wrap"
                name="searchValue"
                value={searchOptions.searchValue}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Row
              className="inquiry-search-button-wrap"
              justify="center"
              style={{ margin: "auto" }}
            >
              <Button
                className="inquiry-search-button search"
                onClick={handleSearch}
              >
                검색
              </Button>
              <Button
                className="inquiry-search-button initial"
                onClick={handleInitialBtnClick}
              >
                초기화
              </Button>
            </Row>
          </Row>
        ) : null}
        <div
          className="product-register-border-box"
          style={{ padding: 0, borderTop: 0, height: "fit-content" }}
        >
          {inquiryList?.length !== 0 ? (
            inquiryList.map((inquiry, idx) => (
              <InquiryComponent
                inquiryData={inquiry}
                total={inquiryList?.length}
                currIdx={idx}
                registerInquiryAnswer={registerInquiryAnswer}
                deleteAnswerBtnClick={deleteAnswerBtnClick}
                key={`inquiry-component-${idx}`}
              />
            ))
          ) : (
            <div className="inquiry-not-exist-text">
              조회된 문의목록이 없습니다.
            </div>
          )}
          <div style={{ textAlign: "center" }}>
            <Pagination
              // showSizeChanger
              pageSize={15}
              // onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 40, marginBottom: 40 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductInquiryComponent;
